import React from 'react'
import { Navigate } from 'react-router-dom'
import { useIdentity } from '@/hooks/auth/useIdentity'

import { isProjectHubRole } from 'src/utils/projectHubRole'
import type { Account } from 'types'

/**
 * Role-aware default landing page.
 *
 * - SALESMAN / SOCIETY → `/projects` (the project hub is their main work
 *   surface; a company oversees all of its salesmen's projects there).
 * - Everyone else → `/dashboard` (the architect/collaborator default).
 *
 * While identity is loading we render `null` so we don't briefly redirect
 * to the wrong destination on a cold reload.
 */
const Home: React.FC = () => {
  const { data: identity, isLoading } = useIdentity<Account>()
  if (isLoading) return null
  if (isProjectHubRole(identity?.account_type)) {
    return <Navigate to="/projects" replace />
  }
  return <Navigate to="/dashboard" replace />
}

export default Home
